<template>
    <div class="files-container">
        <FileCard
            v-for="file in files"
            :key="file._id"
            :file="file"
            :selected="isFileSelected(file)"
            @click="handleDoubleClick"
            @delete="handleDelete"
            @toggleSelection="$emit('fileSelect', $event)"
        />
    </div>
</template>

<script>
import Vue from "vue";
import FileCard from "./FileCard.vue";

export default Vue.extend({
    name: "FilesCardView",
    components: {
        FileCard,
    },
    props: {
        files: {
            type: Array,
            default: () => [],
        },
        selectionMode: {
            type: Boolean,
            default: false
        },
        selectedFiles: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        handleDelete(file) {
            this.$emit("delete", file);
        },
        handleDoubleClick(file) {
            if (!file.isFolder) {
                console.error("Çift tıklanan dosya bir klasör değil:", file);
                return;
            }
            this.$router.push({ name: "Drive Detail", params: { id: file._id } });
            console.log(`[DRIVE] Klasör çift tıklandı: ${file.name}`);
            this.$emit("folderDoubleClick", file._id);
        },
        isFileSelected(file) {
            return this.selectedFiles.some(f => f._id === file._id);
        },
        handleFileClick(file) {
            if (this.selectionMode) {
                this.$emit('fileSelect', file);
            }
        }
    },
});
</script>

<style scoped lang="scss">
.files-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    padding: 20px;
}
</style>
